import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { roomCategories } from "../../config/rooms";
import { RoomCard } from "../RoomCard";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

export const RoomsOverview = () => {
  const { t } = useLanguage();
  return (
    <section className="section bg-sand-50/60" id="zimmer" data-testid="rooms-overview-section">
      <div className="container-x">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <p className="eyebrow">{t.roomsOverview.eyebrow}</p>
            <h2 className="h2 mt-4">{t.roomsOverview.title}</h2>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={0.1}>
            <p className="lede">{t.roomsOverview.text}</p>
            <Link to="/zimmer" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-clay hover:gap-3 transition-[gap] duration-200" data-testid="rooms-overview-all-link">{t.cta.allRooms} <ArrowRight className="h-4 w-4" aria-hidden /></Link>
          </Reveal>
        </div>
        <Stagger className="mt-14 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {roomCategories.map((room, i) => (
            <StaggerItem key={room.id}><RoomCard room={room} index={i} /></StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
